import styled from 'styled-components';

export const MainBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-top: 10%;
`;

export const ImageContainer = styled.div`
   ;
`;
export const SubContent = styled.div``;
export const ShellHeader = styled.div`
  display: block;
  margin-left: 0.5rem;
  font-weight: bold;
  margin-bottom: 0.2rem;
`;

export const ShellFooter = styled.div`
  margin-left: 0.5rem;
`;

export const ShellLogoContainer = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
`;

export const StatusCode = styled.div`
  margin-bottom: 1rem;
  color: #7f7f7f;
`;

export const UserMessage = styled.div`
  font-family: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
  color: #d9d9d9;
`;
